import InitLifyCycle from "@/utils/init_lifecycle/init_lifecycle";
import jsBridge from "@/jsbridge/index";
import { store } from "@/main";
import { isIos } from "@/utils/lodash";
import * as types from "@/store/constants/index_types";
import * as setting_types from "@/store/constants/setting_types";
import SwitchBackground from "@/utils/switch_background";
import LocalizeUtil from "@/services/payment/localize";
import { receiveOpenUrlMsg } from "@/services/payment/super_pay_receive";
import ServiceList from "@/services/serviceList";
import PaymentUtil from "@/services/payment/paymentCache";
import { font_loader } from "@/utils/font_loader/font_loader";
import { logAttribution, mobileconfig } from "@/api/ins_api_new/apis/ins_lunch";
import PresisiteAPIParams from "@/api/ins_api_new/persisits/lunch_params";
import { GETTER_LOGIN_INS_USER_LIST } from "@/store/constants/ins_user_info_types";
import UmengPush from "@/services/umeng_push/umeng_push";
import { act_users_action } from "@/services/earn_coins/observer/act_users_observer";

const initLaunch = () => {
  console.time("applaunch");
  new InitLifyCycle({
    launchParamsAndDeviceInfoReady: async () => {
      // ================= 设备参数和启动参数ready!====================
      // 字体文件加载
      font_loader();
    },
    localSettingReady: async ({ local_file_settings }) => {
      // ================= 本地setting的数据ready!====================

      // 前后台切换监听，安卓返回键监听
      SwitchBackground.init();
      // 安卓才初始化安卓返回键
      // !isIos() && AndroidBack.initial();
      // 存储本地化列表
      if (local_file_settings) {
        LocalizeUtil.savePriceProductIdList(local_file_settings);
      }
      // 初始化act_user_list：
      act_users_action.act_users_map_restore();
    },
    masterUserIdReady: async () => {
      // ================= 主账号id的ready!==========================

      // 初始化和动态增加路由
      store.dispatch(types.INIT_DEFAULT_ROUTER);
    },
    jsFrameDomReady: async () => {
      // ================= Dom 在nextTick回调中ready!====================

      // 判断本地db是否有setting
      const hasNativeSetting =
        store.getters[setting_types.GETTER_SETTING_EXIST];
      // 隐藏掉原生的loading覆盖层
      !hasNativeSetting
        ? setTimeout(() => {
            jsBridge.hideLoading();
          }, 300)
        : jsBridge.hideLoading();
      // log
      console.timeEnd("applaunch");
    },
    masterUserIdLoginedReady: async () => {
      // ================= 主账号id向cg后台登陆ready!====================

      // 更新service list
      ServiceList.updateServiceList();
      // 更新sp apps
      // SuperPayCache.getOnlineApps();
      // app启动需要预先pinad connect
      // connect();
      // app启动先对安卓pinad手动加币
      // PinadCoinAdd.launchAddCoin();
      // umeng init from remote or local
      UmengPush.init();
      Promise.all([
        PaymentUtil.launchExecute()
        // AppFlyerInfo.waitAppFlyerInfo()
      ]).then(() => {
        // xiLaunch();
      });
      isIos() && receiveOpenUrlMsg();
    },
    onlineSettingReady: async () => {
      // ================= 线上的setting拉取成功后的ready!====================

      // 告诉原生最新的web_host是什么地址
      // store.dispatch(setting_types.CONFIG_HY_WEB_HOST);
      // 判断是否获取过最新的setting，如果没有获取过，则更新state状态
      const has_loaded_online_setting: boolean =
        store.getters[setting_types.GETTER_ONLINE_SETTING_STATE];
      !has_loaded_online_setting &&
        store.commit(setting_types.UPDATE_LOADED_ONLINE_SETTING_STATE);
      // 配置好 video ad
      // configVideo();
    },
    insApiLunch: async () => {
      const mid = await PresisiteAPIParams.getMid();
      if (!mid) {
        logAttribution();
      }
      mobileconfig();
      const loginUserList = store.getters[GETTER_LOGIN_INS_USER_LIST];
      if (loginUserList.length > 0) {
        // 需要登录:
        for (const j of loginUserList) {
          mobileconfig(j.user_id, true);
        }
      }
    }
  });
};

export default initLaunch;
